import classNames from 'classnames';
import React, { memo } from 'react';
import { InformationIcon } from 'components/Icons';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import style from './InfoLabel.scss';

type Props = {
  text: string;
  containerStyle?: string;
};

export const InfoLabel: React.FC<Props> = memo(({ text, containerStyle }) => {
  return (
    <div className={classNames(style.container, containerStyle)}>
      <InformationIcon width={24} height={24} color={Color.DARK_BLUE_600} />
      <Text variant="sm">{text}</Text>
    </div>
  );
});
